import { Component } from '@rhtml/component';
import { AngularLayout } from '@rhtml/modifiers';
import { html, LitElement, unsafeCSS } from '@rxdi/lit-html';
import { SteelFabTheme } from '@shared/styles/theme';
import * as PartnersComponentCSS from 'bundle-text:./partners.component.css';
import { BehaviorSubject } from 'rxjs';
import * as exampleLogo1 from 'url:../../../assets/images/icons/partners-test/example-logo-1.png';
import * as exampleLogo2 from 'url:../../../assets/images/icons/partners-test/example-logo-2.png';
import * as exampleLogo3 from 'url:../../../assets/images/icons/partners-test/example-logo-3.png';

const PARTNER_LOGOS = [
  {
    href: '/',
    src: exampleLogo1,
  },
  {
    href: '/',
    src: exampleLogo2,
  },
  {
    href: '/',
    src: exampleLogo3,
  },
];

/**
 * @customElement partners-component
 */
@Component({
  Settings: {
    selector: 'partners-component',
    styles: [SteelFabTheme, unsafeCSS(PartnersComponentCSS)],
    modifiers: [...AngularLayout],
  },
  State(this: PartnersComponent) {
    return this.partners;
  },

  Render: () =>
    function (this: PartnersComponent, partners) {
      return html`
        <section class="section" id="partners-component">
          <div class="container">
            <h2 class="section-title">Партньори</h2>
            <div class="logos">
              ${partners.map(
                (logo, index) => html`
                  <a
                    class="logo-link"
                    href=${logo.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label=${`Partner ${index + 1}`}
                  >
                    <img .src=${logo.src} alt=${`Partner logo ${index + 1}`} />
                  </a>
                `
              )}
            </div>
          </div>
        </section>
      `;
    },
})
export class PartnersComponent extends LitElement {
  private partners = new BehaviorSubject(PARTNER_LOGOS);
}
